import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import FilterIcon from './../icons/filtericon'
import EditIcon from './../icons/EditIcon'
import DeleteIcon from './../icons/DeleteIcon'
import service from '../services'
import moment from 'moment'
import Loader from './loader'
import ReactPaginate from 'react-paginate'
//Redux Connect
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../redux/bindActionCretor';
//sweet alert
import swal from 'sweetalert';
import Cookies from 'universal-cookie';
import PafFpgConvertModal from '../pages/PafFpgConvertModal'
import { ADMIN_CMA_IDS } from '../cosntants'

const cookies = new Cookies();
const mapStateToProps = state => ({
    profileName: state.profileName,
    getLoginRole: state.getLoginRole,
    getLoginAdminByID: state.getLoginAdminByID,
    getLoginUser: state.getLoginUser,
    PostAcceptanceEditListId: state.PostAcceptanceEditListId
})

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActCreators, dispatch);
};
let sub;
let typeWisecFilterData = [];
class PostAcceptanceTable extends Component {
    constructor(props) {
        super(props)

        this.state = {
            Push_project_id:'',
            FpgConvert: false,
            AllFpgConvert: false,
            updated: false,
            exploreListPaf: [],
            userForResendMail: {},
            pageCount: '',
            loaderFlag: false,
            emailLoader: false,
            currentPage: 0,
            perPage: 50,
            resendMailPopup: false,
            offset: 0,
            searchField: '',
            paftype: [
                {
                    name: "ALL",
                    label: "All",
                    value: false
                },
                {
                    name: "Narrative_Features",
                    label: "Narrative Features",
                    value: false
                },
                {
                    name: "Indie_Series",
                    label: "Indie Series/Special Events",
                    value: false,
                },
                {
                    name: "New_Frontier",
                    label: "New Frontier",
                    value: false,
                },
                {
                    name: "Narrative_Shorts",
                    label: "Narrative Shorts",
                    value: false,
                },
                {
                    name: "Documentary_Features",
                    label: "Documentary Features",
                    value: false,
                },
                {
                    name: "Documentary_Shorts",
                    label: "Documentary Shorts",
                    value: false,
                },
            ],
            category:[
               
            ],
            isAbleConvertFPG: false,
            convertFPGError: false,
            pendingOverrideId: null,

        }
        this.apiserve = new service();
    }

    getFilmList = (skip, limit) => {
        this.setState({
            loaderFlag: true
        })
        var data = {
        }

        data.page = skip
        data.limit = limit
        this.apiserve.sendevent("paf|project|projectList", data)

    }

    handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage + 1;
        // page scroll top
        var tbl = document.querySelector(".Paf_list_table");
        tbl.scrollTo(0, 0);

        this.setState(
            {
                currentPage: selectedPage,
                offset: offset,
                loaderFlag: true
            },
            () => {
                localStorage.setItem('currentPage', this.state.currentPage)
                localStorage.setItem('offset', offset)
                localStorage.setItem('perPage', this.state.perPage)
                this.getAllAdminRolecFilter(offset, this.state.perPage);
            }
        );
    };


    componentDidMount = () => {
        if (this.props.profileName.email === "pinaki_saha@sundance.org") {
            this.setState({ updated: true })
        }
        this.apiserve.sendevent("paf|project|getDetail", {});
        this.getPafDetail()
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "paf|project|getDetail":
                    
                    let catArray = []
                    response.data.filmCategoryData.forEach(item=>{
                        let obj = {name : item._id,label:item.name,value:false}
                        catArray.push(obj)
                    })
                    this.setState({ category: catArray})
                    this.forceUpdate()
                    break;
                case "paf|project|projectList":
                    if (!response.error) {
                        this.setState({
                          
                            exploreListPaf: response.data.docs,
                            pageCount: Math.ceil(response.data.totalDocs / this.state.perPage),
                            loaderFlag: false,
                            isAbleConvertFPG: response.data.projectsCount > 0
                        }, () => {
                            if (this.props.updateFpgStatus) {
                                this.props.updateFpgStatus(this.state.isAbleConvertFPG)
                            }
                        })
                    }

                    break;
                case "paf|project|getList":
                    if (!response.error) {
                        
                        this.setState({
                            exploreListPaf: response.data.docs,
                            pageCount: Math.ceil(response.data.totalDocs / this.state.perPage),
                            loaderFlag: false,
                            isAbleConvertFPG: response.data.projectsCount > 0
                        }, () => {
                            if (this.props.updateFpgStatus) {
                                this.props.updateFpgStatus(this.state.isAbleConvertFPG)
                            }
                        })
                    }

                    break;
                case "paf|project|searchProject":
                    if (!response.error) {
                        
                        this.setState({
                            exploreListPaf: response.data.docs,
                            pageCount: Math.ceil(response.data.totalDocs / this.state.perPage),
                            loaderFlag: false,
                            isAbleConvertFPG: response.data.projectsCount > 0
                        }, () => {
                            if (this.props.updateFpgStatus) {
                                this.props.updateFpgStatus(this.state.isAbleConvertFPG)
                            }
                        })
                    }
                    break;
                case "paf|project|remove":
                    if (!response.error) {
                        this.setState({
                            loaderFlag: false,
                        })
                        this.apiserve.sendevent("paf|project|projectList", { limit: this.state.perPage, page: this.state.currentPage, });
                    }
                    break;
                case "pafLoginUser":
                    if (!response.error) {
                        document.cookie = (!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + "PAFUser" : "PAFUser") + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
                        cookies.remove(!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + "PAFUser" : "PAFUser", { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: "/" });
                        cookies.set(!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + "PAFUser" : 'PAFUser', response.data, { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: '/', secure: true });
                        window.open(process.env.REACT_APP_FRONTEND_ORIGIN_PAF)
                    } else {
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    }
                    break;
                case "paf|project|sendMail":
                    if (!response.error) {
                        this.apiserve.success('Email sent!')
                        this.setState({
                            resendMailPopup: false,
                            emailLoader: false,
                            userForResendMail: {}
                        })
                    } else {
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                        this.setState({
                            resendMailPopup: false,
                            emailLoader: false,
                            userForResendMail: {}
                        })
                    }
                    break;
                case 'paf|project|createFilm':
                    if (!response.error) {
                        this.apiserve.success("FPG push successful.");
                        this.apiserve.sendevent("paf|project|projectList", { limit: this.state.perPage, page: this.state.currentPage, });

                    }
                    else {
                        this.apiserve.error("FPG push failed.");
                    }
                    break;
                case 'paf|project|togglePageOverride':
                    if (!response.error) {
                        if (!response.data || !response.data._id) {
                            // Response missing _id — re-fetch the list as a safe fallback
                            this.apiserve.sendevent("paf|project|projectList", { limit: this.state.perPage, page: this.state.currentPage });
                            break;
                        }
                        this.setState(prevState => ({
                            exploreListPaf: prevState.exploreListPaf.map(project =>
                                project._id === response.data._id
                                    ? { ...project, pageOverrideEnabled: response.data.pageOverrideEnabled }
                                    : project
                            ),
                            pendingOverrideId: null
                        }));
                        this.apiserve.success(
                            response.data.pageOverrideEnabled
                                ? 'Page override enabled'
                                : 'Page override disabled'
                        );
                    } else {
                        this.setState({ pendingOverrideId: null });
                        this.apiserve.error(response.data?.error || 'Failed to update page override');
                    }
                    break;
                case 'paf|project|bulkCreateFilms':
                    if (!response.error) {
                        if(response.data.failed && response.data.failed > 0){
                            this.setState({
                                convertFPGError: true,
                                convertFPGErrorData: response.data,
                            })
                        } else {
                            this.apiserve.success("FPG push successful.");
                        }
                        this.apiserve.sendevent("paf|project|projectList", { limit: this.state.perPage, page: this.state.currentPage, });
                    } else {
                        this.apiserve.error("FPG push failed.");
                    }
                    this.setState({loaderFlag: false})
                    break;
                    
                default:
                    break;
            }

        })
    }

    FPGCONVERT = (id) => {


        this.setState({
            FpgConvert: true,
            Push_project_id: id
        })

    }
    AllFPGCONVERT = () => {
        this.setState({
            AllFpgConvert: true,
        })

    }
    closeProject = () => {
        this.setState({
            FpgConvert: false,
            AllFpgConvert: false,
        })
    }
    confirmFpgPush = () => {
        this.setState({
            FpgConvert: false,
          
        })
        let data = {
            projectId: this.state.Push_project_id,
            confirmed : true,

        }
      
        this.apiserve.sendevent("paf|project|createFilm", data);
    }
    confirmAllFpgPush = () => {
        this.setState({
            AllFpgConvert: false,
            loaderFlag:true
        })
        this.apiserve.sendevent("paf|project|bulkCreateFilms", {});
    }
    ViewPartnersUser = (item) => {

        this.props.PostAcceptanceEditList(item._id)
        this.props.history.push(`/paf-projects/${item._id}`)
    }
    editPartnersUser = (id, verified) => {
        this.props.PostAcceptanceEditList(id)
        this.props.history.push(`/paf-project/${id}/Edit`)
    }

    deletePartnersUser = (id) => {
        swal({
            title: "Are you sure you want to delete this record?",
            // text: "You want to delete this record",
            icon: "warning",
            buttons: true,
            closeOnCancel: true,
            closeOnConfirm: true,
            buttons: {
                confirm: { text: 'YES', className: 'yes_confirm' },
                cancel: 'NO'
            },
            className: 'swal-custom-class',
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                let data = {
                    projectId: id
                }
                this.apiserve.sendevent("paf|project|remove", data);
                this.setState({
                    loaderFlag: true,
                })
            }
        });
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
        typeWisecFilterData = []
    };

    handleSearchChange = () => {

        let data = {
            limit: this.state.perPage,
            page: this.state.currentPage,
            filter: this.props.search
        }
        this.apiserve.sendevent("paf|project|projectList", data);
    }

    getPafDetail = () => {
        var data = {
            limit: this.state.perPage,
            page: this.state.currentPage,
        }
        this.apiserve.sendevent("paf|project|projectList", data);
        this.setState({
            loaderFlag: true,
        })
    }

    closePartnerUser = () => {
        this.setState({
            contactFullName: "",
            resendMailPopup: false,
        })
    }
    resendMail = () => {
        var data = {
            projectUserId: this.state.userForResendMail.projectUserId
        }
        this.setState({
            emailLoader: true
        })
        this.apiserve.sendevent("paf|project|sendMail", data)
    }

    sendEmailPopup = (e, user) => {
        this.setState({
            userForResendMail: user,
            userContactFullName: user.userId.email
        }, () => {
            this.setState({
                resendMailPopup: true
            })
        })
    }

    displayPartnercType = (e, selectedInex, isClearStatusType = false) => {
        this.props.clearSearch();
        let index = selectedInex
        let event = e?.target?.checked

        let categoryArray = [...this.state.category]
        categoryArray[index].value = event;
        
        this.setState({
            ...this.state,
            category: categoryArray,
            currentPage: 0
        }, () => {
          if (event) {
                typeWisecFilterData = [...typeWisecFilterData, this.state.category[index].name];
            } else {
                let tempArray = typeWisecFilterData.filter((d) => d !== this.state.category[index].name);
                typeWisecFilterData = tempArray;
            }
            this.getAllAdminRolecFilter(1, this.state.perPage);
        })
    }
    getAllAdminRolecFilter = (skip, limit) => {
        var data = {}
        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }
        if (typeWisecFilterData && typeWisecFilterData.length) {
            data.category = typeWisecFilterData
        }

        data.page = skip
        data.limit = limit
        this.apiserve.sendevent("paf|project|getList", data);
    }
    clearPartnercType = () => {
        let categoryArray = this.state.category.map((e, index) => {
            e.value = false;
            return e
        })
        typeWisecFilterData = [];
        this.setState({ category: categoryArray }, () => {
            this.getAllAdminRolecFilter(this.state.offset, this.state.perPage);
        });
    }
    getOverrideAccess = () => {
        const { profileName, getLoginRole } = this.props;
        if (getLoginRole && getLoginRole.user && getLoginRole.user.role === 'admin') return true;
        if (!profileName || !profileName.CMA) return false;
        const entry = profileName.CMA.find(_ => _.access == ADMIN_CMA_IDS.PAF_PAGE_OVERRIDE);
        return entry ? entry.value : false;
    }

    togglePageOverride = (item) => {
        if (this.state.pendingOverrideId === item._id) return; // prevent double-click
        this.setState({ pendingOverrideId: item._id });
        this.apiserve.sendevent('paf|project|togglePageOverride', {
            projectId: item._id,
            enabled: !item.pageOverrideEnabled
        });
    }

    changeRouteUser = (item) => {
        let data = {
            id: item?.userId?._id
        }
        document.cookie = (!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + "PAFProjectId" : "PAFProjectId") + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
        cookies.remove(!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + "PAFProjectId" : "PAFProjectId", { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: "/" });
        cookies.set(!['prod1', 'prod2', 'prod3'].some(env => process.env.REACT_APP_ENVIRONMENT.includes(env)) ? process.env.REACT_APP_ENVIRONMENT + 'PAFProjectId' : "PAFProjectId", item.projectUserId, { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: '/', secure: true });
        this.apiserve.sendevent("pafLoginUser", data);
    }


    render() {
       
        return (
            <>
                <table className='Paf_list_table film_list_table striped_table'>
                    <thead>
                        <tr >
                            <th className="email_d" style={{ width: "280px" }}> Title </th>
                            <th className="" style={{ width: "220px" }}> Film Freeway Submitter Name </th>
                            <th className="" style={{ width: "220px" }}> Film Freeway Submitter Email </th>
                             <th className="" style={{ width: "200px" }}>
                                <span className="d_flex d_flex_align_center depart_d"> category
                                    <FilterIcon />
                                </span>
                                <div className="tabelData_popup" style={{ width: "254px" }}>
                                    <form>
                                       
                                        <div className="customCheck">
                                            <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                                                <p className="link" onClick={() => this.clearPartnercType(null, null, true)}>Clear All</p>
                                            </div>

                                            <div className="customCheckBox">
                                                <div className="customCheckBox">
                                                </div>
                                                {this.state.category.map((item, i) => (
                                                    <div className="customCheckBox">
                                                        <input
                                                            type="checkbox"
                                                            name={item.name}
                                                            id={item.name}
                                                            value={item.value ? true : false}
                                                            checked={item.value ? true : false}
                                                            onClick={(e) => this.displayPartnercType(e, i)}
                                                        />
                                                        <label htmlFor={item.name}>{item.label}</label>
                                                    </div>
                                                ))
                                                }
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </th>
                            <th className="" style={{ width: "200px" }}> Project User ID </th>
                            <th className="" style={{ width: "120px" }}> Last Logged On </th>
                            <th className="" style={{ width: "120px" }}> Added On </th>
                            <th className="" style={{ width: "120px" }}> Submitted </th>
                            {this.getOverrideAccess() && <th className="" style={{ width: "120px", textAlign: "center" }}> Page Override </th>}
                            <th className="" style={{ width: "200px" }}>  </th>
                        </tr>
                    </thead>
                    <tbody>
                        {this?.state?.exploreListPaf?.map((item) => (
                            <tr key={item.projectUserId} className={`pointer ${item.status === 2 ? 'disable' : ''} ${item?.submitNo === 2 && "com-step"}`} >
                                <td onClick={() => this.ViewPartnersUser(item)} className="email_d" style={{ width: "280px" }}> <p>{(item?.article ? item?.article + ' ' : '')  + item?.title}</p></td>
                                <td onClick={() => this.ViewPartnersUser(item)}> <p>{item.contactFullName || item.userId?.contactFullName}</p></td>
                                <td onClick={() => this.ViewPartnersUser(item)}> <p>{item.userId?.email}</p></td>
                                <td onClick={() => this.ViewPartnersUser(item)}> <p>{item?.category?.name ? item?.category?.name :'-' }</p></td>
                                <td  onClick={() => this.ViewPartnersUser(item)}><p>{item.projectUserId}</p></td>
                                <td onClick={() => this.ViewPartnersUser(item)}> <p> {item.userId?.lastLogin ? moment(item?.userId?.lastLogin).format("L") : ''}</p></td>
                                <td onClick={() => this.ViewPartnersUser(item)}> <p> {moment(item?.createdAt).format("L")}</p></td>
                                <td onClick={() => this.ViewPartnersUser(item)}> <p> {item?.submitNo === 1 ? "Page 1" : item?.submitNo === 2 ? "Pages 2-9" : ""}</p></td>
                                {this.getOverrideAccess() && (
                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                        <input
                                            type="checkbox"
                                            checked={item.pageOverrideEnabled || false}
                                            disabled={this.state.pendingOverrideId === item._id}
                                            onChange={() => this.togglePageOverride(item)}
                                            title={item.pageOverrideEnabled ? 'Page Override: ON — click to disable' : 'Page Override: OFF — click to enable'}
                                            style={{ width: '16px', height: '16px', cursor: this.state.pendingOverrideId === item._id ? 'not-allowed' : 'pointer' }}
                                        />
                                    </td>
                                )}
                                <td className="icon_d" style={{ width: "200px"}}>
                                    <Link onClick={() => this.editPartnersUser(item._id, item.verified)}> <EditIcon /> <div>edit</div>  </Link>
                                    <Link onClick={() => this.deletePartnersUser(item._id)}> <DeleteIcon /><div>delete</div> </Link>
                                    <Link onClick={() => this.changeRouteUser(item)}>
                                        <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6.33203 8.66668L9.66536 6.00001L6.33203 3.33334V5.33334H0.332031V6.66668H6.33203V8.66668Z" fill="#5D737E" />
                                            <path d="M7.66601 -0.000678997C6.87769 -0.00286479 6.09678 0.151395 5.3685 0.453163C4.64023 0.754932 3.97908 1.19821 3.42334 1.75732L4.36601 2.69999C5.24734 1.81865 6.41934 1.33265 7.66601 1.33265C8.91267 1.33265 10.0847 1.81865 10.966 2.69999C11.8473 3.58132 12.3333 4.75332 12.3333 5.99999C12.3333 7.24665 11.8473 8.41866 10.966 9.29999C10.0847 10.1813 8.91267 10.6673 7.66601 10.6673C6.41934 10.6673 5.24734 10.1813 4.36601 9.29999L3.42334 10.2427C4.55601 11.376 6.06267 12.0007 7.66601 12.0007C9.26934 12.0007 10.776 11.376 11.9087 10.2427C13.042 9.10999 13.6667 7.60332 13.6667 5.99999C13.6667 4.39665 13.042 2.88999 11.9087 1.75732C11.3529 1.19821 10.6918 0.754932 9.96351 0.453163C9.23524 0.151395 8.45432 -0.00286479 7.66601 -0.000678997Z" fill="#5D737E" />
                                        </svg>
                                    </Link>
                                    <span className="d_flex" style={{background: '#f2f2f2'}}>
                                        <Link style={{ cursor: item?.confirmed ? 'not-allowed' : 'pointer' }} className={`check_admin ${item?.confirmed ? 'updated' : ''}    m_0`}  onClick={item?.confirmed ? "":() => this.FPGCONVERT(item._id)}>
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M16 0H1.99C0.88 0 0.00999999 0.9 0.00999999 2L0 16C0 17.1 0.88 18 1.99 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM16 12H12C12 13.66 10.65 15 9 15C7.35 15 6 13.66 6 12H1.99V2H16V12ZM13 7H11V4H7V7H5L9 11L13 7Z" fill="white" />
                                            </svg>
                                        </Link>
                                        <Link className={`check_admin ${item?.verified ? 'disable' : ''} m_0`} onClick={(e) => item?.verified ? '' : this.sendEmailPopup(e, item)}>
                                            <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11 13H15V10L20 14.5L15 19V16H11V13ZM18 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H9V14H2V4L10 9L18 4V10H20V2C20 1.46957 19.7893 0.960859 19.4142 0.585786C19.0391 0.210714 18.5304 0 18 0ZM10 7L2 2H18L10 7Z" fill="white" />
                                            </svg>
                                            {item?.verified ? '' : <span className="tooltip_box">Send invitation email</span>}
                                        </Link>
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {this.state.FpgConvert &&
                    <div className="delete_popup_wrapper create_project_alert">
                        <span className="popup_overlay"></span>
                        <div className="popup_inner">
                            <h2 className="popup_title text_center relative">
                                ALERT!
                            </h2>
                            <div className="details">
                                <h3 className="detail_title text_center">You are about to Push this PAF data into. FPG.This process is irreversible. Any change after the push will have to be updated in the FPG back end.  </h3>
                                <h3 className="detail_title text_center">Do you want to proceed? </h3>
                                <div className="content_management">
                                    <div className="field_row text_center">
                                        <button className="grayBTN"
                                            type="button"   
                                            onClick={() => this.confirmFpgPush()}
                                        >YES</button>
                                        <button className="orangeBTN active"
                                            type="button"
                                        onClick={() => this.closeProject()}
                                        >NO</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {this.state.AllFpgConvert &&
                    <div className="delete_popup_wrapper create_project_alert">
                        <span className="popup_overlay"></span>
                        <div className="popup_inner">
                            <h2 className="popup_title text_center relative">
                                ALERT!
                            </h2>
                            <div className="details">
                                <h3 className="detail_title text_center">You are about to Push <b>ALL</b> PAF data for fully submitted projects into the FPG. This process is irreversible and multiple projects can be impacted. Any change after the push will have to be updated in the FPG back end  </h3>
                                <h3 className="detail_title text_center">Do you want to proceed? </h3>
                                <div className="content_management">
                                    <div className="field_row text_center">
                                        <button className="grayBTN"
                                            type="button"   
                                            onClick={() => this.confirmAllFpgPush()}
                                        >YES</button>
                                        <button className="orangeBTN active"
                                            type="button"
                                        onClick={() => this.closeProject()}
                                        >NO</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {/* ReactPaginate  */}
                {this.state.exploreListPaf && this.state.exploreListPaf.length && this.state.exploreListPaf ? (
                    <div className="custom-pagination">
                        <ReactPaginate
                            previousLabel={""}
                            nextLabel={""}
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={this.state.pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={this.handlePageClick}
                            containerClassName={"pagination"}
                            subContainerClassName={"pages pagination"}
                            activeClassName={"active"}
                            forcePage={this.state.currentPage}
                        />
                    </div>
                ) : (
                    ""
                )}
                {/* Loader */}
                {this.state.loaderFlag ? (
                    <Loader />
                ) : (
                    ""
                )}
                {/* For resend Mail */}
                <div className={`user_popup ${this.state.resendMailPopup ? "active" : ''}`}>
                    <span className="popup_overlay" onClick={this.closePartnerUser}></span>
                    <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
                        <div className="approve_popup_header text_center relative">
                            <p>Do you want to send the Verification email to {this.state.userContactFullName} again?</p>
                            <span className="close_popup" onClick={this.closePartnerUser}>
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z" fill="black" />
                                </svg>
                            </span>
                        </div>
                        <div className="content">
                            <div className="field_row text_center">
                                <button className="" onClick={this.closePartnerUser}>NO</button>
                                <button className="active" onClick={this.resendMail}>YES {this.state.emailLoader &&
                                    <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                }</button>
                            </div>
                        </div>
                    </div>
                </div>

                {this.state.convertFPGError && <PafFpgConvertModal errorData={this.state.convertFPGErrorData} closeModal={() => this.setState({convertFPGError: false, convertFPGErrorData: []})} />}
            </>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps, null,{forwardRef: true})(PostAcceptanceTable)
